import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('as-widget-group')
export class WidgetGroup extends LitElement {
  public static styles = css`
    .widget-group {
      background-color: #ffffff;
      padding: 24px;
      height: 100%;
      box-sizing: border-box;
    }

    .widget-group-caption {
      font-family: 'Segoe UI Light', 'Segoe UI', 'Lucida Sans', 'Arial', sans-serif;
      color: #555555;
      font-size: 24px;
      font-weight: lighter;
      margin-bottom: 16px;
    }

    .widget-group-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
  `;

  @property()
  public caption?: string;

  public render() {
    return html`
      <div class="widget-group">
        <div class="widget-group-header">
          ${this.getCaptionElement()}
          <div class="widget-group-items">
            <slot name="items"></slot>
          </div>
        </div>
        <slot></slot>
      </div>
    `;
  }

  private getCaptionElement() {
    if (!this.caption) {
      return null;
    } else {
      return html`<div class="widget-group-caption">${this.caption}</div>`;
    }
  }
}
